import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'Name',

  mixins: [ proxy() ],

  props: {
    service: {
      type: String,
      required: true
    },

    isNew: Boolean,
    disabled: Boolean
  },

  render
}

